import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";
import { Modal } from "@lib/modal";
import { observer } from "mobx-react";
import { useFixBody } from "@state/hooks/shared";

export default observer(function UserDataConfirmAuthPopup() {
	const { t } = useTranslation("user-account");

	const { userAuthStore } = useRootAppStore();

	useFixBody(
		true,
		userAuthStore.userDataConfirmationStore
			.isUserDataConfirmationPopupActive
	);

	if (
		!userAuthStore.userDataConfirmationStore
			.isUserDataConfirmationPopupActive
	) {
		userAuthStore.userDataConfirmationStore.hidePopup();
		return null;
	}

	return (
		<Modal>
			<div className="popup">
				<div className="popup__card">
					<div className="popup__header">{t("INFO")}</div>
					<div className="popup__body">
						<p>{t("ONLINE_USER_DATA_CONFIRMATION_REQUIRED")}</p>
					</div>
					<div className="popup__footer">
						<button
							className="popup__footer__btn btn btn--sml btn--primary--inverted"
							onClick={
								userAuthStore.userDataConfirmationStore
									.hidePopup
							}
							type="button"
						>
							{t("COMMON.CANCEL")}
						</button>
						<Button
							className="popup__footer__btn btn btn--sml btn--primary"
							onClick={
								userAuthStore.userDataConfirmationStore
									.redirectToDataConfirmation
							}
							type="submit"
							btnText={t("CONFIRM")}
						></Button>
					</div>
				</div>
			</div>
		</Modal>
	);
});
